
const initialState = {
  waitShow : false
}

function waitFunc(state = initialState , action) {
switch (action.type) {

  case 'WAITSHOW':
        return {
            waitShow : true
        }
    case 'WITEHIDE':
        return {
            waitShow :false
        }
    default:
    return {
        waitShow :false
    }

    }
}


export default waitFunc;
